
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/boots",
      function () {
        return require("private-next-pages/sneakers/boots.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/boots"])
      });
    }
  